import { render, staticRenderFns } from "./StatementOfDeductData.vue?vue&type=template&id=e1e1ca42"
import script from "./StatementOfDeductData.vue?vue&type=script&lang=js"
export * from "./StatementOfDeductData.vue?vue&type=script&lang=js"
import style0 from "./StatementOfDeductData.vue?vue&type=style&index=0&id=e1e1ca42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports